export default __webpack_public_path__ + "static/media/tbc.d93ed2de.png";